import { DialogContent } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useGetPayoutSettings } from "@src/appV2/redesign/Accounts/PayoutSettings/api/useGetPayoutSettings";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useState } from "react";

import { useSuggestInstantPayActions } from "./hooks/useSuggestInstantPayActions";
import { SuggestInstantPayBottomSheetContent } from "./SuggestInstantPayBottomSheetContent";

interface SuggestInstantPayBottomSheetProps {
  modalState: UseModalState;
  onClose: () => void;
}

export function SuggestInstantPayBottomSheet(props: SuggestInstantPayBottomSheetProps) {
  const { modalState, onClose } = props;

  const { data: payoutSettings } = useGetPayoutSettings();
  const instantPayFee = payoutSettings?.meta.instantPayoutFee ?? 0;

  const { handleDismiss, handleSwitchToInstantPay, isSwitchingToInstantPay } =
    useSuggestInstantPayActions();

  const [isSwitchToInstantPaySuccess, setIsSwitchToInstantPaySuccess] = useState(false);

  useLogEffect(APP_V2_USER_EVENTS.SUGGEST_INSTANT_PAY_BOTTOM_SHEET_VIEWED, undefined, {
    enabled: modalState.modalIsOpen,
  });

  return (
    <BottomSheet modalState={modalState} canDismiss={false}>
      <DialogContent>
        <SuggestInstantPayBottomSheetContent
          instantPayFee={instantPayFee}
          isSwitchToInstantPayLoading={isSwitchingToInstantPay}
          isSwitchToInstantPaySuccess={isSwitchToInstantPaySuccess}
          onSwitchToInstantPay={async () => {
            logEvent(APP_V2_USER_EVENTS.SUGGEST_INSTANT_PAY_SWITCH_CLICKED);
            const success = await handleSwitchToInstantPay();
            if (success) {
              setIsSwitchToInstantPaySuccess(true);
            }
          }}
          onSwitchToInstantPaySuccessShown={() => {
            setIsSwitchToInstantPaySuccess(false);
            onClose();
          }}
          onClose={(dontAskAgain) => {
            logEvent(APP_V2_USER_EVENTS.SUGGEST_INSTANT_PAY_DISMISSED, {
              permanentlyDismissed: dontAskAgain,
            });
            handleDismiss(dontAskAgain);
            onClose();
          }}
        />
      </DialogContent>
    </BottomSheet>
  );
}
